import { CloudApi } from "@/v2/infraestructure/api/cloudapi";
import { useUserStore } from "@/v2/application/stores/userStore";
import { useDevicesStore } from "@/v2/application/stores/devicesStore";

export const getDevices = async () => {
    const cloudApi = new CloudApi();
    const userStore = useUserStore();
    const deviceStore = useDevicesStore();
    const workspaceId = userStore.getWorkspaceId();
    if (!workspaceId) {
        throw new Error("Workspace ID is not available");
    }
    try {
        const response = await cloudApi.getDevices(workspaceId);
        if (response.code == 0) {
            deviceStore.setDevices(response.data);
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error("Error fetching devices:", error);

        return false;
    }
}